import { Pipe, PipeTransform } from '@angular/core';
import {
  IObjectOption,
  SelectOption,
} from '../../components/data-input/form-inputs/form-input-select.component';

@Pipe({
  name: 'SelectionOptionValueToName',
  standalone: true,
})
export class SelectionOptionValueToNamePipe implements PipeTransform {
  transform(
    value: unknown,
    options: SelectOption[],
    nameAttr: string,
    valueAttr?: string
  ): SelectOption {
    if (valueAttr && nameAttr) {
      const match = options.find(
        option => (option as IObjectOption)?.[valueAttr] == value
      ) as IObjectOption;

      return match && Object.prototype.hasOwnProperty.call(match, nameAttr)
        ? match[nameAttr]
        : value;
    } else if (nameAttr) {
      const match = options.find(
        option =>
          (option as IObjectOption)[nameAttr] ==
          (value as IObjectOption)?.[nameAttr]
      ) as IObjectOption;
      return match && Object.prototype.hasOwnProperty.call(match, nameAttr)
        ? match?.[nameAttr]
        : (value + '').includes('[object Object]')
          ? (value + '').replace('[object Object]', '')
          : value;
    }
    return value;
  }

  public findOptionByValue(
    value: unknown,
    options: SelectOption[],
    nameAttr: string,
    valueAttr?: string
  ): SelectOption {
    if (valueAttr && nameAttr) {
      return (
        (options.find(
          option =>
            Object.prototype.hasOwnProperty.call(option, nameAttr) &&
            Object.prototype.hasOwnProperty.call(option, valueAttr) &&
            (option as IObjectOption)?.[valueAttr] == value
        ) as IObjectOption) || value
      );
    } else if (nameAttr) {
      return (
        (options.find(
          option =>
            Object.prototype.hasOwnProperty.call(option, nameAttr) &&
            (option as IObjectOption)[nameAttr] ==
              (value as IObjectOption)?.[nameAttr]
        ) as IObjectOption) || value
      );
    }
    return options.find(o => o == value) as IObjectOption;
  }
}
